module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-57x57-fc793bcee7b57901ad5e56a8b615b13c.png";